import React, { FC, useState } from 'react';
import axios from 'axios';
import { Formik, Field, Form, ErrorMessage } from "formik";
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import ConfirmationModal from '../shared/ConfirmationModal';
import NewconfirmationModal from '../shared/NewconfirmationModal';
import AllFailureModal from '../shared/AllFailureModal';
import nss_payment from '../../images/nss_payment.jpeg';
import { json } from 'stream/consumers';

const UserAdd: FC = () => {
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [status, setStatus] = useState(false);
  const [pendingAction, setPendingAction] = useState<(() => void) | null>(null);
  const [paymentModal, setPaymentModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [showFailureModal, setShowFailureModal] = useState(false);
  const [failureMessage, setFailureMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const validateForm = (values: any) => {
    const errors: any = {};
    if (!/^[6-9]\d{9}$/.test(values.mobile)) {
      errors.mobile = "Mobile number must be 10 digits and start with 6, 7, 8, or 9.";
    }

    return errors;
  };


  const callApiUserAdd = async (values: any, resetForm: any) => {
    setModalMessage("Are you sure you want to add this candidate?");
    setPendingAction(() => async () => {
      try {
        const url = process.env.REACT_APP_API_URL + 'users/adduser';
        const response = await axios.post(url, values, { headers: { "Content-Type": "application/json" } });
        if (response.status === 201) {
          setSuccessMessage("User added successfully.");
          setStatus(true);
          setShowSuccessModal(true);
          resetForm();
          setTimeout(() => navigate('/userslist'), 3000);
        }

      } catch (error: any) {
        if (error.response.status === 400) {
          setFailureMessage("Both Email and Mobile already exists")
        }
        else if (error.response.status === 401) {
          setFailureMessage("Email already exists")
        }
        else if (error.response.status === 402) {
          setFailureMessage("Mobile already exists")
        } else {
          setFailureMessage("Network Error.Failed to add user.");
        }

        setShowFailureModal(true);
      }
    });
    setModalShow(true);
  }

  const handleModalOk = () => {
    setModalShow(false);

    if (pendingAction) {
      pendingAction();
    }
    if (status) {
      const token = localStorage.getItem('jwttoken');
      if (token) {
        navigate('/userslist')
      }
      return {
        error: false
      }
    }
  }

  const handleAddEmployer = async (e: React.MouseEvent, values: any) => {
    setModalMessage("Are you sure you want to add this Employer?");
    setPendingAction(() => async () => {
      try {
        e.preventDefault();
        const url = process.env.REACT_APP_API_URL + 'users/add-employer';
        const response = await axios.post(url, values);
        if (response.status === 201) {
          setSuccessMessage("Employer added successfully.");
          setStatus(true);
          setShowSuccessModal(true);
          setTimeout(() => navigate('/userslist'), 3000);
        }
      } catch (error: any) {
        if (error.response.status === 400) {
          setFailureMessage("Both Email and Mobile already exists")
        }
        else if (error.response.status === 401) {
          setFailureMessage("Email already exists")
        }
        else if (error.response.status === 402) {
          setFailureMessage("Mobile already exists")
        } else {
          setFailureMessage("Network Error.Failed to add Employer.");
        }
        console.error("Error adding user:", error);
        setShowFailureModal(true);

        // if (error.response) {
        //   const errorMessage = error.response.data.message;
        //   setModalMessage(errorMessage);
        // } else {
        //   setModalMessage("Error registering. Please try again.");
        //   setFailureMessage("Error registering. Please try again.");

        // }
      }
    });
    setModalShow(true);
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8}>
          <Card className="shadow">
            <Card.Header className="bg-info text-white text-center">
              <h4>Sign Up</h4>
            </Card.Header>
            <Card.Body>
              <Formik
                initialValues={{ name: "", email: "", mobile: "", password: "" }}
                validate={validateForm}
                validateOnMount={true}
                onSubmit={async (values, { resetForm }) => {
                  await callApiUserAdd(values, resetForm);
                }}
              >
                {({ values, errors, touched }) => (

                  <Form>
                    <Row className="mb-3">
                      <Col md={6}>
                        <label htmlFor="name" className="form-label">
                          Name:
                        </label>
                        <Field
                          name="name"
                          type="text"
                          className="form-control"
                          placeholder="Enter Name" required
                        />
                      </Col>

                      <Col md={6}>
                        <label htmlFor="email" className="form-label">
                          Email:
                        </label>
                        <Field
                          name="email"
                          type="email"
                          className="form-control"
                          placeholder="Enter Email" required
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md={6}>
                        <label htmlFor="mobile" className="form-label">
                          Mobile:
                        </label>
                        <Field
                          name="mobile"
                          type="text"
                          // className="form-control"
                          className={`form-control ${errors.mobile && touched.mobile ? "is-invalid" : ""}`}
                          placeholder="Enter Mobile Number" required
                        />
                        <ErrorMessage name="mobile" component="div" className="text-danger" />
                      </Col>

                      <Col md={6}>
                        <label htmlFor="password" className="form-label">
                          Password:
                        </label>
                        <div className="position-relative">
                          <Field
                            name="password"
                            type={showPassword ? "text" : "password"}
                            className="form-control pe-5"
                            placeholder="Enter Password"
                            required
                          />
                          <i
                            className={`position-absolute top-50 translate-middle-y end-0 me-3 fas ${showPassword ? "fa-eye-slash" : "fa-eye"
                              }`}
                            style={{ cursor: "pointer" }}
                            onClick={() => setShowPassword(!showPassword)}
                          ></i>
                        </div>
                      </Col>
                    </Row>

                    <Row className="mt-4">
                      <Col className="text-center">
                        <Button type="submit" variant="success" disabled={!!errors.mobile}>
                          Add Candidate
                        </Button>

                        <Button className="btn btn-primary m-2" onClick={(e) => { handleAddEmployer(e, values) }} disabled={!!errors.mobile}>
                          Add Employer
                        </Button>

                        <Button variant="danger" className="mx-2" onClick={() => navigate("/userslist")}>
                          Go Back
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <ConfirmationModal
        show={modalShow}
        modalMessage={modalMessage}
        onHide={() => setModalShow(false)}
        confirmation={handleModalOk}
        operationType="Confirm"
      />
      <NewconfirmationModal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} modalMessage={successMessage} operationType="Ok" timeoutDuration={3000} />
      <AllFailureModal show={showFailureModal} onHide={() => setShowFailureModal(false)} modalMessage={failureMessage} operationType="Ok" timeoutDuration={5000} />
    </Container>
  )
}

export default UserAdd
